module.exports = __webpack_public_path__ + "static/6_norsk-6f60b85aef2ce9b69b29cd5c566d64e1.png";